import React, { Component } from 'react';
import { css } from 'aphrodite';
import { Layout, ReportBox, ColorEnvironment, Font, Text, Flexbox } from './Styles';

import Locale from './models/Locale';
import ButtonSet from './ButtonSet';

class About extends Component {
  render() {
    let actions = [[Locale.localized('Take Tutorial'), '/tutorial/1'], [Locale.localized('Skip Tutorial'), '/cities']];
    return(
      <div className={css(Layout.fullScrollingContentArea)}>
        <div className={css(Layout.contentArea)}>
          <div className={css(Flexbox.column, Flexbox.axisStart, Flexbox.crossCenter)}>
            <div className={css(Text.heading, Font.hero)}>{Locale.localized("Get Ready!")}</div>
            <div className={css(Flexbox.column, Flexbox.axisStart, Flexbox.crossCenter, ReportBox.container, ColorEnvironment.normal)}>
              {Locale.locale() === 'en' &&
                <div className={css(Flexbox.grow, Font.body, Text.textBlock)}>
                  <p>Get Ready! The Game of Home Hazard Preparedness is an engaging mobile game created by ICLEI Canada with support from The Co&#8209;operators. The game is designed to educate homeowners and residents about the impacts of natural hazards and extreme weather, and how people can prepare for these events in their home. Choose from real world home improvement and lifestyle adaptation actions to collect points and test your preparedness. Watch how your bank account, quality of life, and preparedness change as you invest in resilience. And watch out for chance cards – life is unpredictable!</p>
                  <p>Play on your desktop, tablet, or mobile smartphone, and share your results with friends on social media!</p>
                </div>
              }
              {Locale.locale() === 'fr' &&
                <div className={css(Flexbox.grow, Font.body, Text.textBlock)}>
                  <p>À vos marques! Le jeu portant sur la préparation aux risques à domicile est une application mobile amusante créée par ICLEI Canada avec le soutien de Co&#8209;operators. Le jeu est conçu pour renseigner les propriétaires et les résidents sur les répercussions des risques naturels et des conditions climatiques extrêmes, et vise à préparer les gens à réagir efficacement à ces événements à la maison. Faites vos choix parmi de véritables projets d’améliorations domiciliaires et mesures d’adaptation du mode de vie pour accumuler des points et mettre votre état de préparation à l’essai. Voyez comment votre compte de banque, votre qualité de vie et votre état de préparation changent à mesure que vous investissez dans la résilience. Aussi, surveillez les cartes « chance » – la vie est imprévisible!</p>
                  <p>Jouez sur votre ordinateur de bureau, tablette ou téléphone intelligent mobile, et partagez vos résultats avec vos amis sur les médias sociaux!</p>
                </div>
              }
              <ButtonSet buttons={actions} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/About.js